<template>
  <v-row justify="center">

    <v-col v-if="!dense" cols="12" class="text-left">
      <h3 class="">{{ $t('delivery.orderPayment') }} </h3>
    </v-col>


    <template v-if="getPaymentMethods">
      <v-col cols="12">
        <v-card>
          <v-card-title v-if="dense" class="pb-0 pt-2">
            Método de Pago <span class="red--text">*</span>
          </v-card-title>

          <v-radio-group dense v-model="localValue" class="mt-0">
            <!--CASH-->
            <template
                v-if="isPaymentMethodsEnable('cash')">
              <v-card-text>
                <v-radio :value="getPaymentMethods.cash.identifier" label="Efectivo"></v-radio>
              </v-card-text>
            </template>

            <!--DEBIT-->
            <template
                v-if="isPaymentMethodsEnable('debit')">
              <v-divider></v-divider>
              <v-card-text>
                <v-radio :value="getPaymentMethods.debit.identifier" label="Débito"></v-radio>
              </v-card-text>
            </template>

            <!--BANK_TRANSFER-->
            <template
                v-if="isPaymentMethodsEnable('bankTransfer')">
              <v-divider></v-divider>
              <v-card-text>
                <v-radio :value="getPaymentMethods.bankTransfer.identifier" label="Transferencia Bancaria"></v-radio>
                <v-alert
                    v-if="localValue === getPaymentMethods.bankTransfer.identifier && getPaymentMethods.bankTransfer.info "
                    type="info"
                >
                  {{ getPaymentMethods.bankTransfer.info }}
                </v-alert>
              </v-card-text>
            </template>

            <!--MP_TRANSFER-->
            <template
                v-if="isPaymentMethodsEnable('mercadoPagoTransfer')">
              <v-divider></v-divider>
              <v-card-text>
                <v-radio :value="getPaymentMethods.mercadoPagoTransfer.identifier"
                         label="Transferencia Mercado Pago"></v-radio>
                <v-alert
                    v-if="localValue === getPaymentMethods.mercadoPagoTransfer.identifier && getPaymentMethods.mercadoPagoTransfer.info "
                    type="info"
                >
                  {{ getPaymentMethods.mercadoPagoTransfer.info }}
                </v-alert>
              </v-card-text>
            </template>

          </v-radio-group>

        </v-card>
      </v-col>

      <v-alert v-if="coupon && couponPaymentMethods && couponPaymentMethods.length > 0" type="info">
        El cupón aplicado limita los medios de pago disponibles.
      </v-alert>


      <v-col v-if="submitButton" cols="12" class="text-right">
        <submit-button
            :text="submitText"
            @click="$emit('confirm')"
            :disabled="!this.localValue"
        ></submit-button>
      </v-col>

    </template>

    <v-col v-else cols="12" class="px-6">
      <loading></loading>
    </v-col>


  </v-row>
</template>

<script>
import {Loading, SubmitButton} from "@dracul/common-frontend"

export default {
  name: "PaymentMethod",
  components: {Loading, SubmitButton},
  props: {
    dense: {type: Boolean, default: false},
    // onlyEnable: {type: Boolean, default: true},
    submitButton: {type: Boolean, default: false},
    submitText: {type: String, default: 'common.next'},
  },
  computed: {
    orderDeliveryMode() {
      return this.$store.getters.orderSystem.order.getDeliveryMode
    },
    couponCode() {
      return this.$store.getters.orderSystem.order.couponCode
    },
    coupon() {
      return this.$store.getters.orderSystem.coupon
    },
    couponPaymentMethods() {
      return this.$store.getters.orderSystem?.coupon?.paymentMethods
    },
    methodMap(){
      let methods = {
        cash: "CASH",
        debit: "DEBIT",
        bankTransfer: "BANK_TRANSFER",
        mercadoPagoTransfer: "MP_TRANSFER"
      }

      return (method) => {
        if(methods[method]){
          return methods[method]
        }
        return method
      }
    },
    isPaymentMethodsEnable() {

      return (method) => {
        if(!this.getPaymentMethods){
          return false
        }

        if(!this.getPaymentMethods[method].enable){
          return false
        }

        if(!this.getPaymentMethods[method].modes.includes(this.orderDeliveryMode)){
          return false
        }

        if(this.couponCode && !this.coupon){
          return false
        }

        if(this.coupon && !this.couponPaymentMethods.includes(this.methodMap(method) )){
          return false
        }

        return true
      }

    },
    localValue: {
      get() {
        return this.$store.getters.orderSystem.order.payment.method
      },
      set(val) {
        this.$store.commit('paymentMethod', val)
      }
    },
    getPaymentMethods() {
      return this.$store.getters.getPaymentMethods
    }
  },
  created() {
    if (this.getPaymentMethods === null) {
      this.$store.dispatch('findPaymentMethods')
    }
    if(this.couponCode && !this.coupon){
      this.$store.dispatch('findCouponByCode', this.couponCode)
    }
  },
}
</script>

<style scoped>

</style>
